import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTiktokIntegrationQuery = createQueryHook(
  ShopRendererApiClient.getTiktokIntegration,
  {
    queryKey: ['tiktokIntegration'],
  },
)
